import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: end;\n  margin-top: 28px;\n\n  button {\n    padding: 12px 20px;\n    font-size: 16px;\n  }\n\n  @media (max-width: 768px) {\n    button {\n      width: 100%;\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ConfirmDialog } from "@bookips/solvook-ui-library";
import styled from "styled-components";
const PayErrorDialog = (param)=>{
    let { open , onClose  } = param;
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        open: open,
        onClose: onClose,
        title: "결제 진행에 오류가 발생했어요.",
        content: /*#__PURE__*/ _jsx("p", {
            children: "고객센터에 문의 해주세요."
        }),
        footer: /*#__PURE__*/ _jsxs(ButtonBox, {
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    variant: "soft",
                    label: "닫기",
                    onClick: ()=>onClose()
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "solid",
                    label: "고객센터 열기",
                    onClick: ()=>window.open("https://solvook.channel.io/home", "_self")
                })
            ]
        })
    });
};
const ButtonBox = styled.div.withConfig({
    componentId: "sc-d9fa32e4-0"
})(_templateObject());
export default PayErrorDialog;
